export default "__VITE_ASSET__DwGQCsoQ__"